import React from 'react';
import PropTypes from 'prop-types';

import { registerFavoritesEvent as registerSnowplowFavoritesEvent } from 'ggApp/modules/gaAnalytics/actions';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import withIntersectionObserver from 'ggApp/modules/tracking/hocs/withIntersectionObserver';
import withOnClickEvent from 'ggApp/modules/tracking/hocs/withOnClickEvent';
import { mappedProductDefaultProps, mappedProductPropTypes } from 'ggApp/modules/product/constants';
import { isFunction } from 'ggApp/utils/function';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import { preorderProductsFromFeatureFlag as preorderProductsFromFeatureFlagSelector } from 'ggApp/modules/featureFlag/selectors';
import { withProductMapper } from './withProductAdapter';
import HorizontalCard from './HorizontalCard';
import VerticalCard from './VerticalCard';

export default class WidgetProductCard extends React.PureComponent {
    onFavoriteCb = ({ isFavorite } = {}) => {
        const { onClickCallback, product } = this.props;
        if (isFunction(onClickCallback)) {
            onClickCallback();
        }

        registerSnowplowFavoritesEvent({ isFavorite, product });
    };

    render() {
        const {
            cardType,
            className,
            product,
            style,
            onClick,
            browserLink,
            preorderProducts,
            activeStore,
            carousel,
            handpickedProduct,
            pdpOpenInNewTabEnabled,
            noCssOnImage,
        } = this.props;
        const preorderProduct = preorderProducts?.find(
            ({ storeCodes, sku }) => sku === product?.sku && storeCodes.includes(activeStore?.code),
        );
        return cardType === 'horizontal' ? (
            <HorizontalCard
                className={className}
                product={product}
                onClick={onClick}
                onClickCallback={this.onFavoriteCb}
                style={style}
                browserLink={browserLink}
                preorderProduct={preorderProduct}
                noCssOnImage={noCssOnImage}
            />
        ) : (
            <VerticalCard
                className={className}
                product={product}
                onClick={onClick}
                onClickCallback={this.onFavoriteCb}
                style={style}
                browserLink={browserLink}
                preorderProduct={preorderProduct}
                carousel={carousel}
                handpickedProduct={handpickedProduct}
                noCssOnImage={noCssOnImage}
            />
        );
    }
}

WidgetProductCard.propTypes = {
    className: PropTypes.string,
    product: mappedProductPropTypes,
    onClick: PropTypes.func,
    onClickCallback: PropTypes.func,
    browserLink: PropTypes.bool,
    style: PropTypes.shape({}),
    cardType: PropTypes.oneOf(['horizontal', 'vertical']),
    preorderProducts: PropTypes.arrayOf(PropTypes.shape({})),
    noCssOnImage: PropTypes.bool,
};

WidgetProductCard.defaultProps = {
    className: '',
    product: mappedProductDefaultProps,
    style: null,
    cardType: null,
    browserLink: false,
    onClick: () => undefined,
    onClickCallback: () => undefined,
    preorderProducts: [],
    noCssOnImage: false,
};

const enhance = compose(
    connect(
        createStructuredSelector({
            preorderProducts: preorderProductsFromFeatureFlagSelector,
            activeStore: activeStoreSelector,
        }),
    ),
);

const EnhancedCard = enhance(WidgetProductCard);

export const Card = withOnClickEvent(withIntersectionObserver(EnhancedCard));

export const CardWithTrackingWithProductMapper = withProductMapper(Card);
export const CardWithProductMapper = withProductMapper(EnhancedCard);
